const _i18n_error = {
  load_geo_info : {
    EN: `load_geo_info failed`,
    KO: `load_geo_info failed`,
    JP: `load_geo_infoは失敗しました`,
  },
}

const _i18n_alert = {
  use_geoip_custom : {
    EN: `require geoip enable`,
    KO: `require geoip enable`,
    JP: `geoipの有効化が必要です`
  },
  require_country : {
    EN: `require country code 2 char`,
    KO: `require country code 2 char`,
    JP: `国コード2文字が必要です`
  }
}

const i18n_toastr = {
  _i18n_error,
  _i18n_alert
}

export default i18n_toastr